
import React, { useMemo } from "react";
import { hearingTypeLabel } from 'helpers/legacyHearingType';
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import { downloadFileResponse } from "helpers/downloadFileResponse";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { removeMultipleCases } from "slices/caseSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { usePermissions } from "layouts/Admin";
import { caseSelector } from "slices/caseSlice";
import { fetchCases } from "slices/caseSlice";
import { setCases } from "slices/caseSlice";
import AddCases from "components/Cases/AddCases";
import { useParams } from "react-router-dom";
import MoveCaseModal from "components/Cases/MoveCase";
import { DownloadIcon } from "lucide-react";
const apiService = new Api();

function CasesTable({ appointment, formattedDate, onCaseChange }) {
    const dispatch = useDispatch()
    const { checkPermission } = usePermissions();
    const { id: apptId } = useParams();
    const { case: courtCase, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(caseSelector);
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [moveModal, setMoveModal] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'hearing_start_time',
        sortDirection: 'asc',
        appt_id: apptId,
    });

    React.useEffect(() => {
        // The component stays mounted when navigating /appointments/view/:id -> another id,
        // and the cases list lives in a SHARED redux store — clear the previous job's cases
        // and reset per-view UI state before fetching this job's cases (keyed on apptId).
        dispatch(setCases({ data: [], total: 0, last_page: 1, current_page: 1 }));
        setSelectedItems([]);
        setSelectAll(false);
        setSearchTerm("");
        setCurrentPage(1);
        dispatch(fetchCases(1, { appt_id: apptId, sortBy: 'hearing_start_time', sortDirection: 'asc' }))
    }, [apptId])

    const handleAddLocationPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            dispatch(fetchCases(1, { appt_id: apptId }))
            hideConfirmDialog()
            onCaseChange && onCaseChange();
        }
        else {
            toast.error(message, { className: "errorToast" });
        }
    };

    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }

    const showMoveConfirmDialog = () => {
        setMoveModal(true);
        return
    };

    const hideMoveConfirmDialog = () => {
        setMoveModal(false);
        return
    };
    const handleRemoveItems = () => {
        dispatch(removeMultipleCases({ ids: selectedItems }, submitCallback))
    }
    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(courtCase?.map((courtCase) => courtCase.id.toString()))


    }

    const handleClose = () => {
        // refAddutton.current.click(); 
        setAddForm({ show: false })
    };

    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchCases(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm, appt_id: apptId }))
        }

        return (
            <tr>
                <th >
                    <div className="row_check">
                        <span>#</span>
                        {(checkPermission('Move Cases') || checkPermission('Delete Cases')) && (
                            <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                        )}
                    </div>
                </th>
                <th >
                    <TableHeaderItem
                        title="Case Number"
                        sortBy="case_number"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>


                <th >
                    <TableHeaderItem
                        title="Name"
                        sortBy="client_name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th >
                    <TableHeaderItem
                        title="Party Type"
                        sortBy="party_type_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th >
                    <TableHeaderItem
                        title="Case Type"
                        sortBy="case_type_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th >
                    <TableHeaderItem
                        title="Service Type"
                        sortBy="service_type"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th >
                    <TableHeaderItem
                        title="Hearing Type"
                        sortBy="hearing_type_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th >
                    <TableHeaderItem
                        title="Hearing Time"
                        sortBy="hearing_start_time"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th >
                    <TableHeaderItem
                        title="Courtroom"
                        sortBy="courtroom_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th >
                    <TableHeaderItem
                        title="Jurisdiction"
                        sortBy="jurisdiction_id"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th >
                    <TableHeaderItem
                        title="Case notes"
                        sortBy="notes"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                {checkPermission('Edit Cases') &&
                    <th >Actions</th>
                }
            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            courtCase?.map((courtCase, index) => (
                <CourtCaseItems courtCase={courtCase} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLocationPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
            ))
        )
    }, [courtCase, selectedItems]);

    //#endregion


    return (
        <ListLayout
            title="Cases"
            time={true}
            buttonTitle="Add case"
            renderTableHeader={renderTableHeader}
            renderTableContent={renderTableContent}
            // TODO: change loation permission with currect keyword 
            addButtonDisabled={appointment?.status === "cancelled" || !checkPermission('Add Cases')}
            totalPages={totalPages}
            fetchList={fetchCases}
            selectedItems={selectedItems}
            handleRemoveItems={handleRemoveItems}
            renderAddForm={(callback) => <AddCases formattedtime={formattedDate} appointment={appointment} item={addForm.item} show={addForm.show} onClose={handleClose} callback={() => { callback(); onCaseChange && onCaseChange(); }} statusPerm={checkPermission('Status Cities')} />}
            refAddutton={refAddutton}
            addForm={addForm}
            showConfirmDialog={showConfirmDialog}
            showMoveConfirmDialog={showMoveConfirmDialog}
            handleAddPopUp={handleAddLocationPopUp}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            loader={loader}
            searchPlaceholder="Search case..."
            noOfItems={total}
            sortConfig={sortConfig}
            hidePagination={true}
            hideMoveButton={!checkPermission('Move Cases')}
            hidePageLength={true}
            disableBootstrap={true}
            hideRemoveButton={!checkPermission('Delete Cases')}
        >
            {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
            {moveModal && <MoveCaseModal onClose={hideMoveConfirmDialog} isOpen={moveModal} selectedItems={selectedItems} setSelectedItems={setSelectedItems} onCaseChange={onCaseChange} />}
        </ListLayout>
    )

}


const CourtCaseItems = ({
    courtCase, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    const formatTime = (timeString) => {
        if (!timeString) return "-";
        const [hours, minutes] = timeString.split(":");
        let hourNum = parseInt(hours);
        const ampm = hourNum >= 12 ? "PM" : "AM";
        hourNum = hourNum % 12 || 12; // Convert 0-23 to 12-hour format
        return `${hourNum.toString().padStart(2, "0")}:${minutes} ${ampm}`;
    }

     const downloadTranslation = async () => {
        try {
            const filePath = courtCase?.translated_document;
            if (!filePath) return;

            const response = await Api.downloadTranslatefile(filePath);
            await downloadFileResponse(response, filePath.split("/").pop());
        } catch (error) {
            console.log("Download error", error);
            toast.error("Download failed.", { className: "errorToast" });
        }
    };
    
    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{serial}</span>
                    {(checkPermission('Move Cases') || checkPermission('Delete Cases')) && (
                        <label className="custom-checkbox checkbox">
                            <input type="checkbox" name="select-all" data-value={courtCase.id} checked={selectedItems.includes(courtCase.id.toString())} onChange={handleChange} />
                            <span className="checkmark"></span>
                        </label>)}
                </div>
            </td>
            <td>
                {courtCase.case_number || 'N/A'}
            </td>
            <td>
                {courtCase.client_name || 'N/A'}
            </td>
            <td>
                {courtCase.party_type?.name}
            </td>
            <td>
                {courtCase.case_type?.name}
            </td>
            <td>
                {courtCase.service_type || '-'}
            </td>
            <td>
                {hearingTypeLabel(courtCase)}
            </td>
            <td>
                {courtCase.service_type === 'Document Translation' ? '-' : formatTime(courtCase.hearing_start_time)}
            </td>
            <td>
                {courtCase.courtroom?.name || '-'}
            </td>
            <td>
                {courtCase.jurisdiction?.name || '-'}
            </td>
            <td>
                {courtCase.notes || '-'}
            </td>
            {checkPermission('Edit Cases') && (
                <td>
                    <div className="d-flex gap-2 align-items-center justify-content-start">
                    <button className="table_edit" onClick={() => handleAddPopUp({ ...courtCase, })}>Edit</button>

                    {courtCase?.translated_document && (
                        <button
                            type="button"
                            className="main_button"
                            onClick={downloadTranslation}
                            title="Download"
                            style={{ padding: '12px 18px' }}
                        >
                            <DownloadIcon size={16}/>
                        </button>
                    )} 
                    </div>
                </td>)}
        </tr>
    )
}



export default CasesTable;
